import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "paoPanel", "printedPanel", "paoField", "printedField"]

  connect() {
    this.selectedValue = this.printedFieldTarget.value ? "printed" : "pao"
    this.updateSelection()
  }

  select(event) {
    this.selectedValue = event.currentTarget.dataset.value

    if (this.selectedValue === "printed") {
      this.paoFieldTarget.value = ""
      delete this.paoFieldTarget.dataset.paoUnsure
      this.dispatchChange(this.paoFieldTarget)
    } else {
      this.printedFieldTarget.value = ""
      this.dispatchChange(this.printedFieldTarget)
    }

    this.updateSelection()
  }

  updateSelection() {
    this.paoPanelTarget.classList.toggle("hidden", this.selectedValue !== "pao")
    this.printedPanelTarget.classList.toggle("hidden", this.selectedValue !== "printed")

    this.optionTargets.forEach(option => {
      const selected = option.dataset.value === this.selectedValue

      option.setAttribute("aria-pressed", selected.toString())
      option.classList.toggle("border-transparent", selected)
      option.classList.toggle("ring-1", selected)
      option.classList.toggle("ring-warm-gray-800", selected)
      option.classList.toggle("text-warm-gray-900", selected)
      option.classList.toggle("border-warm-gray-300", !selected)
      option.classList.toggle("text-warm-gray-700", !selected)
      option.classList.toggle("hover:bg-warm-gray-50", !selected)
    })
  }

  dispatchChange(field) {
    field.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
